import { Box, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  ContinuedLeave,
  Leave,
  LeaveEntity,
  LeaveEntityDateRange,
} from "../../../../entriesAPI";
import { isAllowedContinuationOfType } from "../../../Shared/functions";
import { useCallback, useEffect } from "react";
import isEmpty from "../../../../../../common/helpers/isEmpty";

interface Props {
  leaveEntity: LeaveEntity;
  updateLeaveEntity: (
    key: string,
    value: string | LeaveEntityDateRange | null | Leave,
  ) => void;
}

const ContinuePrevious = ({ leaveEntity, updateLeaveEntity }: Props) => {
  const { t } = useTranslation();

  // Check if the type is allowed to continue.
  // If there are no previous leaves, disable continuation as well.
  const previousLeaves = leaveEntity.previousLeaves.order.filter(
    (id) => id !== leaveEntity.id,
  );
  const isContinuationDisabled =
    !isAllowedContinuationOfType(leaveEntity.type) || isEmpty(previousLeaves);

  const handleRadioChange = useCallback(
    (value: boolean) => {
      const rootId = leaveEntity.previousLeaves.order[0];
      if (rootId) {
        const leave = leaveEntity.previousLeaves.chains[
          rootId
        ][0] as ContinuedLeave;
        updateLeaveEntity("continuationOf", value ? leave : null);
        updateLeaveEntity(
          "continuationOfId",
          value ? leave?.continuationOf ?? leave?.id : null,
        );
      }
    },
    [leaveEntity.previousLeaves, updateLeaveEntity],
  );

  useEffect(() => {
    if (isContinuationDisabled) {
      updateLeaveEntity("continuationOf", null);
      updateLeaveEntity("continuationOfId", null);
    }
  }, [isContinuationDisabled, leaveEntity.continuationOf, updateLeaveEntity]);

  return (
    <Box
      sx={{
        marginTop: "26px",
      }}
    >
      <RadioGroup
        value={leaveEntity.continuationOf ? true : false}
        onChange={(e) =>
          handleRadioChange(e.target.value === "true" ? true : false)
        }
        row
      >
        <FormControlLabel
          disabled={isContinuationDisabled}
          value={true}
          control={<Radio />}
          label={t("hourEntries:continuePrevious")}
        />
        <FormControlLabel
          value={false}
          control={<Radio />}
          label={t("hourEntries:doNotContinuePrevious")}
        />
      </RadioGroup>
    </Box>
  );
};

export default ContinuePrevious;
